import { request } from "graphql-request";

import { CONTENTFUL_GRAPHQL_API_URL } from "@/utils/urls.ts";

import { RoadmapFeature } from "../types";

import { RoadmapFeaturesQuery } from "./gql";

export const ROADMAP_FEATURES_INITIAL_PAGE_SIZE = 50;
export const ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE = 1000;

const CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES =
    typeof window === "undefined"
        ? process.env["CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES"]
        : window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;

export interface RoadmapFeaturesQueryResult {
    roadmapFeatureCollection: {
        total: number;
        items: RoadmapFeature[];
    };
    taxonomyRoadmapAppCollection: {
        items: Array<{
            roadmapAppNameExternal: string;
            filterQueryParam: string;
        }>;
    };
    taxonomyRoadmapCategoryCollection: {
        items: Array<{
            roadmapCategoryNameExternal: string;
            queryParameter: string;
        }>;
    };
    taxonomyRoadmapStatusCollection: {
        items: Array<{
            roadmapStatusNameExternal: string;
        }>;
    };
}

export interface GetRoadmapFeaturesArgs {
    limit?: number;
    skip?: number;
    locale: string;
}

export const getRoadmapFeatures = async (args: GetRoadmapFeaturesArgs) => {
    const { limit, skip, locale } = args;
    return request<RoadmapFeaturesQueryResult>({
        url: CONTENTFUL_GRAPHQL_API_URL,
        document: RoadmapFeaturesQuery,
        variables: { limit, skip, locale },
        requestHeaders: {
            Authorization: `Bearer ${CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};
